module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-点赞-默认.9c815.png";